import { IconMoodPuzzled } from "@tabler/icons-react";

export function Fallback(props: { message?: string }) {
    return (
        <div className="flex h-screen flex-col items-center justify-center gap-8">
            <IconMoodPuzzled className="text-gray-50" size={48} stroke={1.5} />
            <div className="flex flex-col items-center justify-center gap-2">
                <div className="text-sm font-semibold">{props.message || "Something went wrong..."}</div>
                <div className="text-xs text-gray-50">
                    If the problem persists, please contact support at&nbsp;
                    <a href="mailto:help@lumidb.com" className="text-secondary">
                        help@lumidb.com
                    </a>
                </div>
            </div>
            <a href="/" className="text-xs text-secondary">
                Go back home
            </a>
        </div>
    );
}
